<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import SkiSchoolLevel from '../../../components/ski/school/SkiSchoolLevel';
import i18n from '../../../i18n';
import TwCopyAndTranslateModal from '../../../components/TwCopyAndTranslateModal.vue';

export default {
  name: 'SkiSchoolLevels',
  components: {
    TwCopyAndTranslateModal,
    SkiSchoolLevel,
  },
  data() {
    return {
      copyAndTranslateModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      levels: 'skischool/getLevels',
    }),
    ...mapState({
      season: state => state.skischool.season,
      levelsLoading: state => state.skischool.season.levels.itemsLoading,
      levelsError: state => state.skischool.season.levels.itemsError,
      levelSaveLoading: state => state.skischool.season.levels.saveLoading,
      levelSaveError: state => state.skischool.season.levels.saveError,
      domains: state => state.twenty.domains.items,
    }),
    isNewLevelActive() {
      return this.levels.some(level => level.id === undefined);
    },
    errorOccurred() {
      return this.levelsError || this.levelSaveError;
    },
    getCopyValues() {
      const values = [];

      this.levels.forEach(level => {
        values.push(
          {
            globalModelId: level.id,
            globalModelColumnName: 'ski_school_season_level_id',
            selectKeyOverrides: [ 'domain_id', 'ski_school_season_level_id' ],
            tableName: 'domain_ski_school_season_level',
            sourceDomainId: null,
            selectedFromDomain: null,
            fromLanguageIsoOverride: null,
            sourceIsoOverride: null,
            disableSourceIsoOverride: true,
            toDomains: [],
            shouldTranslate: false,
            shouldCopySeo: false,
            fieldNamesAndValuesToCopyAndTranslate: [
              { name: level.name },
              { domain_id: null },
              { ski_school_season_level_id: level.id },
            ],
            title: `Level: ${level.name}`,
          },
        );
      });
      return values;
    },
  },
  methods: {
    ...mapActions({
      loadLevels: 'skischool/levelsByIdLoad',
      addNewLevel: 'skischool/levelAddNew',
      createLevel: 'skischool/levelCreate',
      saveLevel: 'skischool/levelSave',
      removeLevel: 'skischool/levelRemove',
      setLevel: 'skischool/setLevel',
    }),
    createOrUpdate(level) {
      if (level.id) {
        this.saveLevel(level);
      } else {
        this.createLevel(level);
      }
    },
    remove(levelId) {
      // eslint-disable-next-line no-alert
      if (!levelId || confirm(i18n.t('ski.skiLevel.removeAreYouSure'))) {
        this.removeLevel(levelId);
      }
    },
    onLevelChange(payload) {
      this.setLevel(payload);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skischool/levelsByIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container class="pa-0">
    <div>
      <h2 class="d-inline-block">
        {{ $t('ski.skiLevels.title') }}
        ({{ Object.keys(levels).length }})
      </h2>
      <v-btn
        :disabled="isNewLevelActive
          || levelsLoading
          || levelSaveLoading
        "
        class="mb-2"
        color="success"
        outline
        @click="addNewLevel"
      >
        {{ $t('ski.skiLevels.new') }}
      </v-btn>
      <v-btn
        :loading="levelsLoading"
        icon
        @click="loadLevels(season.id)"
      >
        <v-icon>cached</v-icon>
      </v-btn>
      <v-btn
        v-if="levels.length"
        :loading="levelsLoading"
        color="primary success"
        @click="copyAndTranslateModalOpen = !copyAndTranslateModalOpen"
      >
        Copy/translate
      </v-btn>
      <tw-copy-and-translate-modal
        v-if="copyAndTranslateModalOpen"
        :elements-to-handle="getCopyValues"
        :domains="domains"
      />
    </div>
    <div class="text-center">
      <v-progress-linear
        v-if="levelsLoading || levelSaveLoading"
        :indeterminate="true"
      />
    </div>
    <v-alert
      :value="errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"/>
    </v-alert>
    <v-layout v-if="levels.length" wrap>
      <v-flex sm2 xs12 offset-sm1>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiLevel.nameSupplier') }}</p>
      </v-flex>
      <v-flex sm2 xs12>
        <p class="font-weight-bold pl-2 pt-2">Global Name</p>
      </v-flex>
      <v-flex sm2 xs12>
        <p class="font-weight-bold pl-2 pt-2">Domain Name</p>
      </v-flex>
      <v-flex sm1 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiLevel.priority') }}</p>
      </v-flex>
      <v-flex sm2 xs12/>
    </v-layout>
    <v-layout
      v-for="(level) in levels"
      :key="'ski-level-' + level.id"
      :loading="levelsLoading"
      xs12
    >
      <ski-school-level
        :level="level"
        :save-loading="levelSaveLoading"
        @onLevelChange="onLevelChange"
        @createOrUpdate="createOrUpdate"
        @remove="remove"
      />
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/school/SkiSchoolSeasonLevels.vue